import { cva } from 'class-variance-authority';

/**
 * Visual presets for the benefits section. `compact` tightens the vertical spacing and gives each
 * benefit pod a lighter dark-mode surface; it is the look used on the KenoGO home page.
 *
 * Add a key here rather than reintroducing per-slot `className` props: the whole point of the
 * density token is that one word describes one complete look.
 */
type BenefitsSectionDensity = 'default' | 'compact';

const benefitItemClasses = cva('border border-border', {
  variants: {
    density: {
      default: 'bg-container-base',
      compact: 'bg-container-base dark:bg-container',
    },
  },
  defaultVariants: { density: 'default' },
});

const benefitWrapperClasses = cva('', {
  variants: {
    density: {
      default: 'py-10',
      compact: 'py-8',
    },
  },
  defaultVariants: { density: 'default' },
});

const benefitTitleClasses = cva('display-l', {
  variants: {
    density: {
      default: 'mb-5 md:mt-15',
      compact: 'mb-8 md:mt-0',
    },
  },
  defaultVariants: { density: 'default' },
});

const benefitButtonClasses = cva('', {
  variants: {
    density: {
      default: 'md:mb-15',
      compact: 'md:mb-0',
    },
  },
  defaultVariants: { density: 'default' },
});

export { benefitButtonClasses, benefitItemClasses, benefitTitleClasses, benefitWrapperClasses };
export type { BenefitsSectionDensity };
